import { DefaultProductOptions } from '../analytics-context-types';
import { getModalTag, getPODProductTag } from './utils';

export const getSeeFileRequirementTag = (options: DefaultProductOptions) => {
  const level2 = 'Address the Envelope - Recipient';
  const modalEvent = [
    {
      eventInfo: {
        eventName: 'link click',
        eventAction: 'see file requirement',
      },
    },
  ];
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const { modal, user } = getModalTag(options.productType, level2, modalEvent, options.projectID);

  const newModal = {
    ...modal,
    messages: [{ statusMessages: '' }],
  };

  return {
    modal: newModal,
    product,
    user,
  };
};
